export type DocNavItem = {
	title: string
	href: string
}

export type DocNavSection = {
	title: string
	items: DocNavItem[]
}

export const docsNav: DocNavSection[] = [
	{
		title: "Getting Started",
		items: [
			{ title: "Introduction", href: "/docs" },
			{ title: "Quickstart", href: "/docs/quickstart" },
		],
	},
	{
		title: "Browser SDK",
		items: [{ title: "SDK Reference", href: "/docs/rum" }],
	},
	{
		title: "Integrations",
		items: [
			{ title: "Overview", href: "/docs/integrations" },
			{ title: "React", href: "/docs/integrations/react" },
			{ title: "Next.js", href: "/docs/integrations/nextjs" },
			{ title: "Vue", href: "/docs/integrations/vue" },
			{ title: "SvelteKit", href: "/docs/integrations/svelte" },
			{ title: "Angular", href: "/docs/integrations/angular" },
			{ title: "HTML / Script Tag", href: "/docs/integrations/html" },
		],
	},
	{
		title: "Alert Channels",
		items: [
			{ title: "Overview", href: "/docs/alerts" },
			{ title: "Slack", href: "/docs/alerts/slack" },
			{ title: "Discord", href: "/docs/alerts/discord" },
			{ title: "PagerDuty", href: "/docs/alerts/pagerduty" },
			{ title: "Email", href: "/docs/alerts/email" },
			{ title: "Webhook", href: "/docs/alerts/webhook" },
		],
	},
	{
		title: "API Reference",
		items: [
			{ title: "Overview", href: "/docs/api" },
			{ title: "Authentication", href: "/docs/api#authentication" },
		],
	},
	{
		title: "Resources",
		items: [
			{ title: "Guides", href: "/guides" },
			{ title: "Blog", href: "/blog" },
			{ title: "Compare", href: "/compare" },
		],
	},
]
